import moment from "moment";

/**
 * Formats a date as a relative time (e.g., "2 days ago").
 * Returns "Unknown" if the date is null or undefined.
 * @param date - The date to format.
 * @returns A string representing the relative time from now or "Unknown" if date is invalid.
 */
export function formatRelativeTime(
  date: string | Date | null | undefined
): string {
  if (!date) return "Unknown";
  return moment(date).fromNow();
}

/**
 * Formats a duration given in seconds into a human-readable format (e.g., "1 hour, 30 minutes").
 * @param seconds - The duration in seconds.
 * @returns A formatted string representing the duration.
 */
export function formatDuration(seconds: number): string {
  return moment.duration(seconds, "seconds").format("h [hours], m [minutes]");
}

export function toUtcMidnightFromYMD(ymd: string): Date | null {
  // Accepts "YYYY-MM-DD"
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
  if (!m) return null;
  const [_, y, mo, d] = m;
  return new Date(Date.UTC(+y, +mo - 1, +d, 0, 0, 0, 0));
}

export function ymd(date: Date): string {
  // YYYY-MM-DD in UTC
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const d = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function utcMidnightToday(): Date {
  const now = new Date();
  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  );
}

export function formatNumber(n: number) {
  n.toLocaleString(undefined, { maximumFractionDigits: 0 });
}